'use client'

import { useEffect, useState } from 'react'
import { Tab, TabGroup, TabList, TabPanel, TabPanels } from '@headlessui/react'
import clsx from 'clsx'

import { Contenedor } from './Contenedor'
import backgroundImage from '../../imagenes/fondo-caracteristicas.jpg'
import screenshotConectar from '../../assets/demo/screens/cropped/agregar_tienda.png'
import screenshotAnalizar from '../../assets/demo/screens/cropped/mis_tiendas.png'
import screenshotRelacionar from '../../assets/demo/screens/cropped/relacionar_tiendas.png'
import screenshotTablero from '../../assets/demo/screens/cropped/tablero.png'

const caracteristicas = [
  {
    titulo: 'Conectar Tiendas',
    descripcion:
      'Conecta y gestiona todas tus tiendas de Mercado Libre y Amazon en una sola plataforma.',
    imagen: screenshotConectar,
  },
  {
    titulo: 'Analizar Detalladamente',
    descripcion:
      'Visualiza métricas clave de cada tienda: ventas, tráfico, conversiones y rendimiento de anuncios.',
    imagen: screenshotAnalizar,
  },
  {
    titulo: 'Relacionar Tiendas',
    descripcion:
      'Encuentra productos idénticos entre marketplaces con IA y compara su rendimiento automáticamente.',
    imagen: screenshotRelacionar,
  },
  {
    titulo: 'Tablero Unificado',
    descripcion:
      'Visualiza el rendimiento de todas tus tiendas y canales de venta en un solo lugar.',
    imagen: screenshotTablero,
  },
]

export function CaracteristicasPrincipales() {
  let [orientacionPestanas, setOrientacionPestanas] = useState('horizontal')

  useEffect(() => {
    let consultaMediaLg = window.matchMedia('(min-width: 1024px)')

    function onCambioConsultaMedia({ matches }) {
      setOrientacionPestanas(matches ? 'vertical' : 'horizontal')
    }

    onCambioConsultaMedia(consultaMediaLg)
    consultaMediaLg.addEventListener('change', onCambioConsultaMedia)

    return () => {
      consultaMediaLg.removeEventListener('change', onCambioConsultaMedia)
    }
  }, [])

  return (
    <section
      id="caracteristicas"
      aria-label="Características para gestionar tus marketplaces"
      className="relative overflow-hidden bg-blue-600 pb-28 pt-20 sm:py-32"
    >
      <img
        className="absolute left-1/2 top-1/2 max-w-none translate-x-[-44%] translate-y-[-42%]"
        src={backgroundImage}
        alt=""
        width={2245}
        height={1636}
      />
      <Contenedor className="relative">
        <div className="max-w-2xl md:mx-auto md:text-center xl:max-w-none">
          <h2 className="font-display text-3xl tracking-tight text-white sm:text-4xl md:text-5xl">
            Todo lo que necesitas para impulsar tu negocio en línea.
          </h2>
          <p className="mt-6 text-lg text-blue-100">
            Desde análisis detallados hasta optimización de listados, Kompa te proporciona las herramientas para destacar en el competitivo mundo del e-commerce.
          </p>
        </div>
        <TabGroup
          className="mt-16 grid grid-cols-1 items-center gap-y-2 pt-10 sm:gap-y-6 md:mt-20 lg:grid-cols-12 lg:pt-0"
          vertical={orientacionPestanas === 'vertical'}
        >
          {({ selectedIndex }) => (
            <>
              <div className="-mx-4 flex overflow-x-auto pb-4 sm:mx-0 sm:overflow-visible sm:pb-0 lg:col-span-5">
                <TabList className="relative z-10 flex gap-x-4 whitespace-nowrap px-4 sm:mx-auto sm:px-0 lg:mx-0 lg:block lg:gap-x-0 lg:gap-y-1 lg:whitespace-normal">
                  {caracteristicas.map((caracteristica, indiceCaracteristica) => (
                    <div
                      key={caracteristica.titulo}
                      className={clsx(
                        'group relative rounded-full px-4 py-1 lg:rounded-l-xl lg:rounded-r-none lg:p-6',
                        selectedIndex === indiceCaracteristica
                          ? 'bg-white lg:bg-white/10 lg:ring-1 lg:ring-inset lg:ring-white/10'
                          : 'hover:bg-white/10 lg:hover:bg-white/5',
                      )}
                    >
                      <h3>
                        <Tab
                          className={clsx(
                            'focus:outline-none font-display text-lg ui-not-focus-visible:outline-none',
                            selectedIndex === indiceCaracteristica
                              ? 'text-blue-600 lg:text-white'
                              : 'text-blue-100 hover:text-white lg:text-white',
                          )}
                        >
                          <span className="absolute inset-0 rounded-full lg:rounded-l-xl lg:rounded-r-none focus:outline-none" />
                          {caracteristica.titulo}
                        </Tab>
                      </h3>
                      <p
                        className={clsx(
                          'mt-2 hidden text-sm lg:block',
                          selectedIndex === indiceCaracteristica
                            ? 'text-white'
                            : 'text-blue-100 group-hover:text-white',
                        )}
                      >
                        {caracteristica.descripcion}
                      </p>
                    </div>
                  ))}
                </TabList>
              </div>
              <TabPanels className="lg:col-span-7">
                {caracteristicas.map((caracteristica) => (
                  <TabPanel key={caracteristica.titulo} unmount={false}>
                    <div className="relative sm:px-6 lg:hidden">
                      <div className="absolute -inset-x-4 bottom-[-4.25rem] top-[-6.5rem] bg-white/10 ring-1 ring-inset ring-white/10 sm:inset-x-0 sm:rounded-t-xl" />
                      <p className="relative mx-auto max-w-2xl text-base text-white sm:text-center">
                        {caracteristica.descripcion}
                      </p>
                    </div>
                    <div className="mt-10 w-[45rem] overflow-hidden rounded-xl bg-slate-50 shadow-xl shadow-blue-900/20 sm:w-auto lg:mt-0 lg:w-[67.8125rem]">
                      <img
                        className="w-full"
                        src={caracteristica.imagen}
                        alt=""
                        sizes="(min-width: 1024px) 67.8125rem, (min-width: 640px) 100vw, 45rem"
                      />
                    </div>
                  </TabPanel>
                ))}
              </TabPanels>
            </>
          )}
        </TabGroup>
      </Contenedor>
    </section>
  )
}